export default {
  methods: {
    sendGAEvent(action, extra) {
      if (window.gtag) {
        window.gtag('event', action, { event_category: 'Wizard', ...extra });
      }
    },
  },
};
